module.exports = __webpack_public_path__ + "img/icon_advantage_product@2x.04197dc8.png";